/**
 * Legacy jQuery/Vue plugins (jquery-ui, bootstrap-sass, admin-lte, bootstrap-datepicker,
 * select2, jquery-slimscroll, jquery.floatThead, ...) expect `window.$`/`window.jQuery`
 * (and some inline Blade <script> blocks expect `window.moment`/`window.Vue`) to already
 * exist the moment they're loaded — they don't `import` these themselves.
 *
 * Under the old Mix/webpack build, `require()` calls executed strictly in the order
 * written, so assigning `window.jQuery` before requiring those plugins worked fine.
 * Under native ES modules, `import` declarations are hoisted and evaluated in order
 * BEFORE any of the importing module's own top-level statements — regardless of where
 * they're textually written — so an inline `window.jQuery = $` statement placed
 * "before" a later `import 'jquery-ui/...'` in the same file actually still runs AFTER
 * it. That throws `ReferenceError: jQuery is not defined` inside the plugin, which
 * aborts the whole module's evaluation (breaking everything below it too).
 *
 * Fix: put the window assignments in their own module and `import` it FIRST (as the
 * very first line) in any entry file that also side-effect-imports jQuery plugins.
 * ES modules fully evaluate an imported module (this one) before moving on to the
 * next sibling import in the parent file, so this is guaranteed to run first.
 */
import $ from 'jquery';
import moment from 'moment';
import Vue from 'vue';

window.$ = window.jQuery = $;
window.moment = moment;
window.Vue = Vue;

